import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './par-currency.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ParCurrencyDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const parCurrencyEntity = useAppSelector(state => state.parCurrency.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="parCurrencyDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.parCurrency.detail.title">ParCurrency</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{parCurrencyEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.parCurrency.code">Code</Translate>
            </span>
          </dt>
          <dd>{parCurrencyEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.parCurrency.name">Name</Translate>
            </span>
          </dt>
          <dd>{parCurrencyEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.parCurrency.nameAr">nameAr</Translate>
            </span>
          </dt>
          <dd>{parCurrencyEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.parCurrency.nameEn">nameEn</Translate>
            </span>
          </dt>
          <dd>{parCurrencyEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.parCurrency.status">Status</Translate>
            </span>
          </dt>
          <dd>{parCurrencyEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/par-currency" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/par-currency/${parCurrencyEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ParCurrencyDetail;
